export { default as Base } from './Base';
export { default as Text } from './Text';
export { default as View } from './View';
export { default as Image } from './Image';
export { default as Ico } from './Ico';
export { default as Input } from './Input';
export { default as Textarea } from './Textarea';
export { default as Radio } from './Radio';
export { default as AreaSelect } from './areaSelect';
export { default as Tab } from './Tab';
export { default as MenuSale } from './MenuSale';
export { default as Prompt } from './Prompt';
